import axios, { AxiosError } from "axios"
import { LIST_PATH, REJECTION_CAUSE_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getRejectionCauseService = async () => {
  try {
    const result = await instance.get(REJECTION_CAUSE_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createRejectionCauseService = async (rejectionCause: any) => {
  try {
    const result = await instance.post(REJECTION_CAUSE_PATH, rejectionCause)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteRejectionCauseService = async (id: any) => {
  try {
    const result = await instance.delete(REJECTION_CAUSE_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editRejectionCauseService = async (
  id: number,
  rejectionCause: any
) => {
  try {
    const result = await instance.put(
      REJECTION_CAUSE_PATH + `/${id}`,
      rejectionCause
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
